module.exports = __webpack_public_path__ + "img/footer_logo.bf0ea76d.svg";